import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-745da756")

_pushScopeId("data-v-745da756")
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "time-range-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, "開始", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, "終了", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_time_edit_box = _resolveComponent("time-edit-box")

  return (_openBlock(), _createBlock("div", {
    class: ["vue-flex-column", _ctx.$mq]
  }, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.resultTitle[_ctx.resultIndex][_ctx.kartePartsIndex]), 1),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_time_edit_box, {
        modelValue: _ctx.startTime[_ctx.resultIndex][_ctx.kartePartsIndex],
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.startTime[_ctx.resultIndex][_ctx.kartePartsIndex] = $event)),
        interval: _ctx.appointmentTimeUnit,
        readonly: _ctx.readonly
      }, null, 8, ["modelValue", "interval", "readonly"]),
      _hoisted_4,
      _createVNode(_component_time_edit_box, {
        modelValue: _ctx.endTime[_ctx.resultIndex][_ctx.kartePartsIndex],
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.endTime[_ctx.resultIndex][_ctx.kartePartsIndex] = $event)),
        interval: _ctx.appointmentTimeUnit,
        readonly: _ctx.readonly
      }, null, 8, ["modelValue", "interval", "readonly"])
    ])
  ], 2))
})